import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { getIsLoggedIn } from 'lib/core/data/auth/session/selectors'
import { usePath, useWishlist } from 'lib/core/hooks'

import { Toast } from 'lib/ui/components'
import { ReactComponent as WishlistSvg } from 'resources/svg/icons/heart.svg'
import { ReactComponent as HeartEmpty } from 'resources/svg/icons/heart-empty.svg'
import { Container } from './styled'

interface Props {
  sku: string
  hasText?: boolean
}

export const AddToWishlist: React.FC<Props> = ({ sku, hasText = false }) => {
  const path = usePath()
  const history = useHistory<{ from?: string, AddToWishlist?: boolean } | undefined>()
  const location = useLocation()
  const { handleRemoveFromWishlist, handleAddToWishlist, isAddedToWishlist, isLoading } = useWishlist(sku)
  const isLoggedIn = useSelector(getIsLoggedIn)
  const AddToWishlistOnLoad = history.location.state?.AddToWishlist

  const handleAddItem = () => {
    if (!isLoggedIn) {
      Toast.toastFailure({ messageId: 'wishlist.not.loggedin' })
      history.push({
        pathname: path.login,
        state: {
          from: location.pathname,
          AddToWishlist: true
        }
      })
    } else {
      if (isAddedToWishlist) {
        handleRemoveFromWishlist()
      }
      handleAddToWishlist()
    }
  }

  useEffect(() => {
    if (AddToWishlistOnLoad) {
      handleAddItem()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Container
        isAdded={isAddedToWishlist}
        isLoading={isLoading}
        onClick={handleAddItem}
      >
        {isAddedToWishlist ? (
          <WishlistSvg />
        ) : (
          <HeartEmpty />
        )}
        {hasText && (
          <span>Wishlist</span>
        )}

      </Container>
    </>
  )
}
